import { render, staticRenderFns } from "./ClientDashboard.vue?vue&type=template&id=1bfa0876"
import script from "./ClientDashboard.vue?vue&type=script&lang=js"
export * from "./ClientDashboard.vue?vue&type=script&lang=js"
import style0 from "./ClientDashboard.vue?vue&type=style&index=0&id=1bfa0876&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports